// DOM Ready
function documentReady(fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}

// Hamburger Animation
$(".hamburger").click(function () {
    $(this).toggleClass("is-active");
});

$(".js-nav-control").click(function () {
    $('body').toggleClass('open');
});

// Smooth Scroll Animation



$('.js-blog-carousel').slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 2,
            }
        },
        {
            breakpoint: 600,
            centerMode: true,
            centerPadding: '60px',
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: false,

            }
        }
    ]

});

// HOMEPAGE REVIEWS
(function (window, $) {
    $(document).ready(function () {
      $('.curated-reviews-slider').slick({
          arrows: false,
          infinite: true,
          centerMode: true
      });
    })
})(window, jQuery);

// CHANGE IMAGE WITH VARIANT CHANGE
(function (window, $) {
    $(document).ready(function () {
        $('body')
            .on('change', '#productSelect', function (event) {
                // Update Price
                var selected = this.options[this.selectedIndex],
                    variantPrice = selected.dataset.price;

                $('#productPrice').text(variantPrice);

                /** Update image Slider */
                var variantImage = selected.dataset.image;
                var position = -1;

                $('.product-thumbs .single-thumb').each(function () {
                    if ($(this).data('image') == variantImage) {
                        position = parseInt($(this).data('slick-index'));
                        return;
                    }
                });

                if (position != -1) {
                    $('.product-thumbs').find('.js-slider-thumbs').slick('slickGoTo', position);
                }


                /** Update Nutritions table tab content */
                if (this.options.length > 1 && window.product_variants !== undefined) {
                    product_variants.forEach((variant_meta) => {
                        if (variant_meta.id == selected.value) {
                            for (const [key, value] of Object.entries(variant_meta)) {
                                $(`.js-meta-${key}`).empty().html(value);
                            }
                        }
                    });
                }
            })
    })
})(window, jQuery);


// Footer Nav
function resizeHandler() {
    if ($(window).width() < 767) {
        $('.footer-nav ul').hide();
        $('.footer-nav ul').slideUp(200);
    } else {
        $('.footer-nav ul').show();
        $('.footer-nav-header').removeClass("expanded");
    }
}

resizeHandler();

$(window).resize(resizeHandler);

$('body').on('click', '.footer-nav-header', function () {
    if ($(window).width() < 767) {
        $(this).next().slideToggle(200);
        $(this).toggleClass("expanded");
    }
});

document.addEventListener("DOMContentLoaded", function() {
    const targetNode = document.querySelector('.template-product');
    if (!targetNode) return;

    const wrapElements = () => {
        const headerTitle = targetNode.querySelector('.stamped-header-title');
        const header = targetNode.querySelector('.stamped-header');
        
        if (headerTitle && header) {
            const wrapper = document.createElement('div');
            wrapper.className = 'stamped-header-main';
            
            wrapper.appendChild(headerTitle.cloneNode(true));
            wrapper.appendChild(header.cloneNode(true));
            
            headerTitle.parentNode.replaceChild(wrapper, headerTitle);
            header.parentNode.removeChild(header);
            
            observer.disconnect();
        }
    };

    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length) {
                wrapElements(); 
            }
        });
    });

    const config = { childList: true, subtree: true };

    observer.observe(targetNode, config);

    wrapElements();
});

const parentElement = document.querySelector('.reelUp_cards_carousel .reelUp_slider_heading');
const newDivElement = document.createElement('div');

const newParagraphElement = document.createElement('p');

newParagraphElement.textContent = 'Hands-on highlights sent to us by members of the DOC’S community.';
newDivElement?.appendChild(newParagraphElement);
parentElement?.appendChild(newDivElement);

// Mobile Safari adjustments
document.addEventListener('DOMContentLoaded', function() {
    function isMobileSafari() {
        const userAgent = navigator.userAgent;
        return /iP(ad|od|hone)/i.test(userAgent) && /WebKit/i.test(userAgent) && !(/(CriOS|FxiOS|OPiOS|mercury)/i.test(userAgent));
    }

    function injectCSS(css) {
        const head = document.head || document.getElementsByTagName('head')[0];
        const style = document.createElement('style');
        head.appendChild(style);
        style.appendChild(document.createTextNode(css));
    }

    if (isMobileSafari()) {
        const css = `.bsub-widget input[type=radio] { margin-top: 33px; }::-webkit-details-marker { display:none; }`;
        injectCSS(css);
    }
});



// Countdown Timer
const countdownTimer = {
    showTimer: function () {
        const offHours = document.querySelectorAll('.pdp-off-hours');
        const onHours = document.querySelectorAll('.pdp-on-hours');
        offHours.forEach(element => {
            element.style.display = 'none';
        });
        onHours.forEach(element => {
            element.style.display = 'flex';
        });
    },
    hideTimer: function () {
        const offHours = document.querySelectorAll('.pdp-off-hours');
        const onHours = document.querySelectorAll('.pdp-on-hours');
        onHours.forEach(element => {
            element.style.display = 'none';
        });
        offHours.forEach(element => {
            element.style.display = 'flex';
        });
    },
    isHoliday: function(){
        const timeZone = 'America/New_York';
        const now = new Date().toLocaleString('en-US', { timeZone });

        
        
        

        

        // List of dates to check against
        const datesToCheck = [
            '12/24/2023','12/25/2023','12/31/2023','01/01/2024','01/15/2024','05/27/2024','07/03/2024','07/04/2024','09/02/2024','11/27/2024','11/28/2024','11/29/2024','12/24/2024','12/25/2024'
        ];

        // Convert today's date to the format MM/DD/YYYY
        const formattedDate = new Date(now).toLocaleDateString('en-US', {
            timeZone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });

        // Check if today's date is in the list
        return datesToCheck.includes(formattedDate);
    },
    isWeekDay: function(){
        const currentDate = new Date();
        const currentDay = currentDate.getDay(); // 0 (Sunday) to 6 (Saturday)

        // Check the Holiday schedule first
        if (countdownTimer.isHoliday()){
            return false;
        }

        // Check if the current day is Monday (1) through Friday (5)
        return currentDay >= 1 && currentDay <= 5;
    },
    isBetween9AM2PM_EST: function(){
        const timeZone = 'America/New_York';
        const now = new Date();
        const currentSecond = now.getSeconds();
        const options = { timeZoneName: 'short' };

        const currentTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone });
        const currentHour = currentTime.split(':')[0];
        const currentMinute = currentTime.split(':')[1];

        
        

        const countdownStartTime = parseInt(9);
        const countdownEndTime = parseInt(14) - 1;

        // Check if the current time is between 9:00 AM and 2:00 PM in EST
        if (currentHour >= countdownStartTime && currentHour <= countdownEndTime) {
            // Calculate remaining time until 2:00 PM
            const remainingHours = 13 - currentHour;
            const remainingMinutes = 60 - currentMinute;
            const remainingSeconds = 59 - currentSecond;
            const remainingTime = `${remainingHours}:${remainingMinutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
            return `${remainingTime}`;
        } else {
            return false;
        }
    },
    updateTime: function(remainingTime){
        if (!remainingTime) {
            countdownTimer.hideTimer();
            window.clearInterval(window.timerInterval);
            return;
        }
        const countdownTimerEl = document.querySelectorAll('.pdp-on-hours .countdown-timer');
        countdownTimerEl.forEach(element => {
            element.innerHTML = remainingTime;
        })
    }
}

documentReady(function () {
    // If it is Monday through Thursday
    if (countdownTimer.isWeekDay()) {
        const remainingTime = countdownTimer.isBetween9AM2PM_EST();

        // If this is between 9:00 AM and 2:00 PM EST
        if (remainingTime !== false) {
            countdownTimer.updateTime(countdownTimer.isBetween9AM2PM_EST());
            window.timerInterval  = setInterval(() => countdownTimer.updateTime(countdownTimer.isBetween9AM2PM_EST()), 1000);
            countdownTimer.showTimer();
        }
        // Not between 9:00 AM and 3:00 PM EST
        else {
            countdownTimer.hideTimer();
        }
    }
    // Not Monday through Thursday
    else {
        countdownTimer.hideTimer();
    }
});
